import { borderRadius, breakpoints, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid var(--border-default);
  ${borderRadius.r1};
  border-radius: 4px;
  background: inherit;

  @media ${breakpoints.lg} {
    display: none;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  height: 48px;
  width: 100%;
  padding: 0px 16px;
  border: none;
  border-radius: 24px;
  background-color: var(--surface-default);
  ${typographyV2.bodyBase}
  color: var(--text-soft);
  margin-bottom: auto;

  > span {
    margin-left: 8px;
  }

  @media ${breakpoints.lg} {
    display: none;
  }
`;
